import { UUID } from '@hfc/common/src/types/UUID';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';
import { ChallengeType } from '@/application/shared/domain/ChallengeQuestionSettings';
import { CCAccountDataResponse } from '@/shared/domain/CCAccountDataResponse';

export class GetCCAccountDataUseCase implements UseCase<[APPLICATION_TYPES, ChallengeType, UUID], SfApiResponse<CCAccountDataResponse>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (input: [APPLICATION_TYPES, ChallengeType, UUID]): Promise<SfApiResponse<CCAccountDataResponse>> {
    const [type, challengeType, uuid] = input;

    return await this.repository.getCCAccountData(type, challengeType, uuid);
  }

}
